import { Switch as MuiSwitch, SwitchProps } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React from 'react'

import colors from '../../../theme/colors'

const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.petrol,
    '&:hover': {
      backgroundColor: alpha(colors.petrol, theme.palette.action.hoverOpacity)
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.petrol
  }
}))

export interface CustomSwitchProps extends SwitchProps {
  small?: boolean
}

const CustomSwitch = React.forwardRef<HTMLButtonElement, CustomSwitchProps>(
  ({ small = false, ...props }, ref) =>
    small ? (
      <StyledSwitch disableRipple size="small" ref={ref} {...props} />
    ) : (
      <StyledSwitch disableRipple ref={ref} {...props} />
    )
)

CustomSwitch.propTypes = {
  small: PropTypes.bool
}
export default CustomSwitch
